module.exports = __webpack_public_path__ + "static/media/kcc.e66244bf.jpg";